import { FC, ReactNode } from 'react';
import { Heading } from '@kpa/kul';
import { HeadingLevel, HeadingLevelStyle } from '@kpa/kul/lib/components/Heading/Heading';
import { ContentResponse } from '../types/shared';
import { RubrikBlockResponse } from '../types/blocks';

interface IRubrikBlock {
  contentResponse: ContentResponse;
}

const RubrikBlock: FC<IRubrikBlock> = ({
  contentResponse,
}): ReactNode => {
  const rubrikBlockResponse = contentResponse.content as RubrikBlockResponse;

  return (
    <>
      <header>
        {rubrikBlockResponse.rubrik && (
          <Heading
            headingLevel={(rubrikBlockResponse.nivå ?? 1) as HeadingLevel}
            headingLevelStyle={(rubrikBlockResponse.storlek) as HeadingLevelStyle}
          >
            {rubrikBlockResponse.rubrik}
          </Heading>
        )}
      </header>
    </>
  );
};

export default RubrikBlock;
